import type { IOrgRepository } from '../repositories/IOrgRepository.js';
import type { OrgEntity } from '../entities/OrgEntity.js';

export interface ListOrgsInput {
  limit?: number;
  offset?: number;
}

interface Dependencies {
  orgRepository: IOrgRepository;
}

export function createListOrgsUseCase({ orgRepository }: Dependencies) {
  return async function listOrgs(input?: ListOrgsInput): Promise<OrgEntity[]> {
    return orgRepository.list({
      limit: input?.limit,
      offset: input?.offset,
    });
  };
}
